import {message, Modal} from "antd";

export const dataAdjustmentOffer = async (data, ymaps) => {
  let newData = {};
  newData.offer_id = data.offerId;
  newData.request_id = data.requestId;
  newData.t2 = data.t2;
  newData.t4 = data.t4;
  newData.t6 = data.t6;
  newData.t7 = data.t7;
  newData.t8 = data.t8;
  newData.t9 = data.t9;
  newData.sh1 = data.sh1;
  newData.sh2 = data.sh2;
  newData.sh3 = data.sh3;
  newData.kp1t = data.kp1t;
  newData.kp2t = data.kp2t;
  newData.kp3t = data.kp3t;
  newData.kp4t = data.kp4t;
  newData.kp1p = data.kp1p;
  newData.kp2p = data.kp2p;
  newData.kp3p = data.kp3p;
  newData.kp4p = data.kp4p;
  newData.kz1t = data.kz1t;
  newData.kz2t = data.kz2t;
  newData.kz3t = data.kz3t;
  newData.kz4t = data.kz4t;
  newData.kz1p = data.kz1p;
  newData.kz2p = data.kz2p;
  newData.kz3p = data.kz3p;
  newData.kz4p = data.kz4p;
  newData.kp1rc_datetime = data.kp1urc;
  if (data.driver) {
    newData.driver_name = data.driver;
  }
  // newData.driver = data.driverId;
  if (data.driverId) {
    newData.drivers = [data.driverId];
  }

  newData.price = data.priceNoNds;
  newData.total_price = data.totalPrice;

  newData.company_executor_id = data.performer;
  newData.responsible_id = data.dispatcher;

  newData.arrival_datetime =
    (data.arrivalDatetime &&
      data.arrivalDatetime.format("YYYY-MM-DD HH:mm:ss")) ||
    null;

  newData.action_datetime =
    (data.actionDatetime &&
      data.actionDatetime.format("YYYY-MM-DD HH:mm:ss")) ||
    null;

  newData.monetization_template_name = data.monetizationTemplateName;
  newData.monetization_template_name_check = data.monetizationTemplateNameCheck;

  if (data.serviceType) {
    switch (data.serviceType) {
      case "simple": {
        data.responsibleDocumentsKeyList = [
          "plist",
          "cc",
          "wo",
          "receipt",
          "waybill",
          "ra",
          "ordrep"
        ];
        break;
      }
      case "kids": {
        data.responsibleDocumentsKeyList = [
          "clist",
          "alist",
          "workphys",
          "fplist",
          "kidsnight",
          "arrland",
          "hwi",
          "di",
          "rp",
          "gn",
          "gi",
          "cc",
          "wo",
          "waybill",
          "receipt",
          "ra",
          "ordrep"
        ];
        break;
      }
      case "undefined": {
        data.responsibleDocumentsKeyList = [
          "cc",
          "wo",
          "waybill",
          "receipt",
          "ra",
          "ordrep"
        ];
        break;
      }
      default: {
        break;
      }
    }
    data.responsibleDocumentsKeyList.forEach(key => {
      if (
        newData.responsible_documents_list &&
        newData.responsible_documents_list.length > 0
      ) {
        newData.responsible_documents_list.push({
          is_client: data[key],
          document_type_key: key
        });
      } else {
        newData.responsible_documents_list = [
          {
            is_client: data[key],
            document_type_key: key
          }
        ];
      }
    });
  }

  if (data.predPay || data.pay || data.postPay) {
    newData.payments = [];
    if (data.predPayChecked && data.predPay && data.predPay.length > 0) {
      data.predPay.forEach(item => {
        if (data[`predPayPrice${item}`] && data[`predPaymentTime${item}`]) {
          newData.payments.push({
            payment_type_id: 1,
            payment: data[`predPayPrice${item}`],
            payment_time:
              data[`predPaymentTime${item}`] &&
              data[`predPaymentTime${item}`].format("YYYY-MM-DD HH:mm:ss")
          });
        } else if (
          data[`predPayPrice${item}`] &&
          !data[`predPaymentTime${item}`]
        ) {
          throw new Error("Укажите дату предоплаты");

          // message.error("Укажите дату предоплаты");
        }
      });
    }
    if (data.payChecked && data.pay && data.pay.length > 0) {
      if (data[`payPrice`]) {
        newData.payments.push({
          payment_type_id: 2,
          payment: data[`payPrice`],
          payment_time:
            (data[`arrivalDatetime`] &&
              data[`arrivalDatetime`].format("YYYY-MM-DD HH:mm:ss")) ||
            null
        });
      }
    }
    if (data.postPayChecked && data.postPay && data.postPay.length > 0) {
      data.postPay.forEach(item => {
        if (data[`postPayPrice${item}`] && data[`postPaymentTime${item}`]) {
          newData.payments.push({
            payment_type_id: 3,
            payment: data[`postPayPrice${item}`],
            payment_time:
              data[`postPaymentTime${item}`] &&
              data[`postPaymentTime${item}`].format("YYYY-MM-DD HH:mm:ss")
          });
        } else if (
          data[`postPayPrice${item}`] &&
          !data[`postPaymentTime${item}`]
        ) {
          throw new Error("Укажите дату постоплаты");
          // message.error("Укажите дату постоплаты");
        }
      });
    }

    newData.payments = newData.payments.map(item => ({
      ...item,
      payment_time_add:
        data.surchargePaymentDate &&
        data.surchargePaymentDate.format("YYYY-MM-DD HH:mm:ss"),
      return_time:
        data.surchargePaymentDate &&
        data.refundFreighterDate.format("YYYY-MM-DD HH:mm:ss"),
      payment_method_id: data.priceAddPayment
    }));
  }

  if (data.additionalServices && data.additionalServices.length > 0) {
    newData.service_additional = [];
    data.additionalServices.forEach(key => {
      newData.service_additional.push({
        service_additional_key: key,
        service_additional_price: data[`serviceAdditionalPrice${key}`]
      });
    });
  }

  newData.vehicle_id = data.vehicleId;
  newData.vehicle_type_id =
    data.vehicleTypeId === "Автобус"
      ? 1
      : data.vehicleTypeId === "Микроавтобус"
      ? 2
      : 3;

  newData.comment = data.carrierComment || " ";

  newData.routes = data.routes.map((item, index) => {
    return {
      ...item,
      duration: data[`routeDuration${index}`].format("HH:mm:ss")
    };
  });

  if (ymaps) {
    const markers = data.routes.map(route => {
      return [route.latitude, route.longitude];
    });

    await new ymaps.route(markers)
      .then(route => {
        route.getPaths().each((item, index) => {
          if (index !== newData.routes.length) {
            newData.routes[index + 1]["route_length"] =
              item.properties.getAll().RouterRouteMetaData.Length.value &&
              Math.round(
                item.properties.getAll().RouterRouteMetaData.Length.value / 100
              );
            newData.routes[index + 1]["route_time"] =
              item.properties.getAll().RouterRouteMetaData.Time.value &&
              Math.round(
                item.properties.getAll().RouterRouteMetaData.Time.value
              );
          }
        });
      })
      .catch(error => {
        if (error.message === "can't construct a route") {
          Modal.error({
            content: "Проложить наземный маршрут невозможно!",
            title: "Внимание!",
            okText: "Закрыть",
            destroyOnClose: true,
            width: 432
          });
        } else {
          message.error("Произошла ошибка");
        }
        throw new Error();
      });
  }

  // ХАРДКОД ВРЕМЕННЫЙ

  newData.offer_status_id = 1;
  return newData;
};
export const adjustMonetizationTemplateData = data => {
  let newData = {};
  newData.t2 = data.t2;
  newData.t4 = data.t4;
  newData.t6 = data.t6;
  newData.t7 = data.t7;
  newData.t8 = data.t8;
  newData.t9 = data.t9;
  newData.sh1 = data.sh1;
  newData.sh2 = data.sh2;
  newData.sh3 = data.sh3;
  newData.kp1t = data.kp1t;
  newData.kp2t = data.kp2t;
  newData.kp3t = data.kp3t;
  newData.kp4t = data.kp4t;
  newData.kp1p = data.kp1p;
  newData.kp2p = data.kp2p;
  newData.kp3p = data.kp3p;
  newData.kp4p = data.kp4p;
  newData.kz1t = data.kz1t;
  newData.kz2t = data.kz2t;
  newData.kz3t = data.kz3t;
  newData.kz4t = data.kz4t;
  newData.kz1p = data.kz1p;
  newData.kz2p = data.kz2p;
  newData.kz3p = data.kz3p;
  newData.kz4p = data.kz4p;
  newData.monetization_template_name = data.monetizationTemplateName;

  return newData;
};
